import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { minDate } from "../../Constants/Constants";

const AddDataModal = ({
  // handleChange,
  // setimgfile,
  // handleAddDataSubmit,
  // formRef,
  getData,
  // file,
}) => {
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [company, setCompany] = useState([]);
  const [companyID, setcompanyId] = useState("");
  const [file, setFile] = useState({});
  const [rowAddData, setRowAddData] = useState({
    doc_name: "",
    doc_type: "",
    doc_renewal_dt: "",
    doc_reminder_before: "",
    doc_file_name: "",
    mail_to: "",
    comapnay_id: "",
  });

  function resetFileds() {
    setRowAddData({
      doc_name: "",
      doc_type: "",
      doc_renewal_dt: "",
      doc_reminder_before: "",
      doc_file_name: "",
      mail_to: "",
      comapnay_id: "",
    });
    setcompanyId("");
    setFile("");
  }

  const formRef = useRef(null);
  // console.log("rowData", rowAddData)

  const setimgfile = (e) => {
    setFile(e.target.files[0]);
    // console.log(e.target.files[0])
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("doc_file", file);
    formData.append("doc_name", rowAddData.doc_name);
    formData.append("doc_type", rowAddData.doc_type);
    formData.append("doc_renewal_dt", rowAddData.doc_renewal_dt);
    formData.append("doc_reminder_before", rowAddData.doc_reminder_before);
    formData.append("mail_to", rowAddData.mail_to);
    formData.append("company_id", companyID);

    let BASE_URL = SERVER_URL + `/api/compliance/document/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        resetFileds();
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    setcompanyId(e.target.value);
  };
  return (
    <div
      className="modal custom-modal fade"
      id="exampleModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
              Add Compliances
            </h5>
            <button
              type="button"
              className="custon-close-button-color close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={resetFileds}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  {/* <h4 className="card-title">Add Data</h4> */}
                  <form
                    className="form-sample"
                    ref={formRef}
                    onSubmit={handleAddDataSubmit}
                  >
                    {/* <p className="card-description">Personal info</p> */}
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Company Name</label>
                          <select
                            className="form-control form-control-lg"
                            onChange={handleCompanyChange}
                            value={companyID}
                            required
                          >
                            <option value="">Select Company Name</option>
                            {company &&
                              company?.length > 0 &&
                              company?.map((item, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <option
                                      value={item.id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  </React.Fragment>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="name">Document Name</label>

                          <input
                            type="text"
                            className="form-control"
                            name="doc_name"
                            id="name"
                            placeholder="Document Name"
                            onChange={handleChange}
                            required
                            autoComplete="off"
                            value={rowAddData.doc_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="Document Type">Document Type</label>
                          <input
                            type="text"
                            className="form-control"
                            name="doc_type"
                            id="Document Type"
                            placeholder="Document Type"
                            onChange={handleChange}
                            required
                            autoComplete="off"
                            value={rowAddData.doc_type}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="Document Renewal">
                            Document Renewal Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="doc_renewal_dt"
                            id="Document Renewal"
                            placeholder="Document Renewal Date"
                            onChange={handleChange}
                            required
                            autoComplete="off"
                            value={rowAddData.doc_renewal_dt}
                            min={minDate}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="Document Reminder">
                            Document Reminder
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            name="doc_reminder_before"
                            id="Document Reminder"
                            placeholder="Document Reminder"
                            onChange={handleChange}
                            required
                            autoComplete="off"
                            min="1"
                            value={rowAddData.doc_reminder_before}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="mail">Mail</label>
                          <input
                            type="email"
                            className="form-control"
                            name="mail_to"
                            id="mail"
                            placeholder="Mail"
                            onChange={handleChange}
                            required
                            autoComplete="off"
                            value={rowAddData.mail_to}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>File upload</label>
                          <div className="input-group col-xs-12">
                            <input
                              type="file"
                              name="doc_file"
                              id="fileInput"
                              className="file-upload-default"
                              onChange={setimgfile}
                              style={{ display: "none" }} // Hide the file input
                              autoComplete="off"
                            />
                            <input
                              type="text"
                              className="form-control file-upload-info"
                              value={file.name || ""}
                              readOnly
                              placeholder="Upload Image"
                            />
                            <label
                              htmlFor="fileInput"
                              className="file-upload-browse btn btn-primary"
                              type="button"
                            >
                              Upload
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary mr-2 mt-3"
                      type="submit"
                      // onClick={handleAddDataSubmit}
                    >
                      Save
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDataModal;
